import Vue from "vue";
import Vuex from "vuex";

// modules
import api from "./modules/api";
import apiTeams from "./modules/api/teams";
import auth from "./modules/auth";
import commitments from "./modules/commitments";
import confirmationDialog from "./modules/confirmationDialog";
import goals from "./modules/goals";
import meeting from "./modules/meeting";
import meetingAgenda from "./modules/meetingAgenda";
import myCommitments from "./modules/myCommitments";
import oneOnOneCreationModal from "./modules/oneOnOneCreationModal";
import pastMeetings from "./modules/pastMeetings";
import schedule from "./modules/schedule";
import settings from "./modules/settings";
import sidebar from "./modules/sidebar";
import teamCommitments from "./modules/teamCommitments";
import teamCreationModal from "./modules/teamCreationModal";
import teamHealth from "./modules/teamHealth";
import teamHealthSurvey from "./modules/teamHealthSurvey";
import teamManagement from "./modules/teamManagement";
import teamOverview from "./modules/teamOverview";
import trialEndDialog from "./modules/trialEndDialog";
import userProfile from "./modules/userProfile";

// plugins
import createLogger from "@/lib/logger";
import { plugin as reactiveArrowGetters } from "@/helpers/enhancedArrowGetters";

Vue.use( Vuex );

const debug = process.env.NODE_ENV !== "production";
const plugins = [
	reactiveArrowGetters,
];

export const store = new Vuex.Store( {
	modules: {
		api,
		apiTeams,
		auth,
		commitments,
		confirmationDialog,
		goals,
		meeting,
		meetingAgenda,
		myCommitments,
		oneOnOneCreationModal,
		pastMeetings,
		schedule,
		settings,
		sidebar,
		teamCommitments,
		teamCreationModal,
		teamHealth,
		teamHealthSurvey,
		teamManagement,
		teamOverview,
		trialEndDialog,
		userProfile,
	},
	strict: debug,
	plugins: debug ? plugins.concat( [ createLogger(), ] ) : plugins,
} );



// WEBPACK FOOTER //
// ./src/store/store.js